import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal, hideModalContent, showModalContent} from "../../../actions/nodeEditorPanelActions";
import AllItemsPanel from "./AllItemsPanel";
import OutputPanel from "./OutputPanel";
import BasicOutputPanel from "./BasicOutputPanel";
import BlenderPanel from "./BlenderPanel";
import SwitchPanel from "./SwitchPanel";
import CombinatorPanel from "./CombinatorPanel";
import PanelHeader from "../components/PanelHeader";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import PredictorFirstBlockPanel from "./PredictorFirstBlockPanel";
import ItemFilterPanel from "./ItemFilterPanel";
import SorterPanel from "./SorterPanel";
import SorterOnlyPanel from "./SorterOnlyPanel";
import NoItemsPanel from "./NoItemsPanel";
import InputItemsPanel from "./InputItemsPanel";
import PValueRangePanel from "./PValueRangePanel";
import DynamicPropertyPanel from "./DynamicPropertyPanel";
import AlgorithmPanel from "./AlgorithmPanel";
import GroupByPropertyPanel from "./GroupByPropertyPanel";
import EditorialPanel from "./EditorialPanel";
import PushPanel from "./PushPanel";
import FieldModifierPanel from "./FieldModifierPanel";
import CachePanel from "./CachePanel";
import PagerPanel from "./PagerPanel";
import LogicToContextPanel from "./LogicToContextPanel";
import ContextPropertyModifierPanel from "./ContextPropertyModifierPanel";
import ComponentPanel from "./ComponentPanel";
import ContextToFirstPanel from "./ContextToFirstPanel";
import CustomPanel from "./CustomPanel";
import CommonPanel from "./CommonPanel";
import ABTestPanel from "./ABTestPanel";
import ContextUpdaterPanel from "./ContextUpdaterPanel";
import ContextModifierPanel from "./ContextModifierPanel";

class NodePanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nodeTitle: this.props.clickedNodeInfo.name
        };
    }

    componentWillUnmount() {
        this.props.hideModal(this.props.node);
    }

    render() {
        const nodeSectionType = this.props.node.sectionType;
        const nodeEditorPanelClass = this.props.content ? `node-editor-panel ${nodeSectionType} active` : `node-editor-panel ${nodeSectionType}`;

        const displayRelatedPanel = () => {
            switch (this.props.node.nodeName) {
                case 'all_items':
                    return <AllItemsPanel/>;
                case 'output':
                    return <OutputPanel/>;
                case 'basic_output':
                    return <BasicOutputPanel/>;
                case 'blender':
                    return <BlenderPanel/>;
                case 'switch':
                    return <SwitchPanel/>;
                case 'a_b_test':
                    return <ABTestPanel/>
                case 'cache':
                    return <CachePanel/>;
                case 'combinator':
                    return <CombinatorPanel/>;
                case 'predictor_first_block':
                    return <PredictorFirstBlockPanel/>;
                case 'item_filter':
                    return <ItemFilterPanel/>;
                case 'sorter':
                    return <SorterPanel/>;
                case 'pager':
                    return <PagerPanel/>;
                case 'sorter_only':
                    return <SorterOnlyPanel/>;
                case "no_items":
                    return <NoItemsPanel/>;
                case "input_items":
                    return <InputItemsPanel/>;
                case "component":
                    return <ComponentPanel/>;
                case "p_value_range":
                    return <PValueRangePanel/>;
                case "dynamic_property":
                    return <DynamicPropertyPanel/>;
                case "algorithm":
                    return <AlgorithmPanel/>;
                case "custom":
                    return <CustomPanel/>;
                case "group_by_property":
                    return <GroupByPropertyPanel/>;
                case "logic_to_context":
                    return <LogicToContextPanel/>;
                case "search_first_block":
                    return <CommonPanel SFBPredictor={true}/>;
                case "editorial":
                    return <EditorialPanel/>;
                case "push":
                    return <PushPanel/>;
                case "field_modifier":
                    return <FieldModifierPanel/>;
                case "context_property_modifier":
                    return <ContextPropertyModifierPanel/>;
                case "context_updater":
                    return <ContextUpdaterPanel/>;
                case "context_modifier":
                    return <ContextModifierPanel/>;
                case "context_to_first":
                    return <ContextToFirstPanel/>;
                case "scoring":
                    return <CommonPanel/>
                default:
                    return '';
            }
        };
        return (
            <div className={nodeEditorPanelClass}>
                <PanelHeader/>
                {this.props.content && displayRelatedPanel()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, showModalContent, hideModalContent, clickedNodeAction})(NodePanel);
